import * as React from 'react';
import { useIntl } from 'react-intl';
import { getManageAttributesNavigationLinks } from '../../../../constants/navigation.constants';
import { useRouteParams } from '../../../../infrastructure/hooks/use-route-params';
import { Navigation } from '../../../_events/_manage-event/shared/navigation/navigation';

export const ManageAttributesNavigation = (): JSX.Element => {
    const { accountId } = useRouteParams();

    const intl = useIntl();
    const links = getManageAttributesNavigationLinks(accountId, intl);

    return <Navigation links={links} />;
};